import classNames from 'classnames'
import { format, isPast, parse } from 'date-fns'
import { observer } from 'mobx-react'
import React from 'react'

import ErrorStore from '../../stores/ErrorStore'
import reservationStore from '../../stores/ReservationStore'
import { AllotmentStatus } from '../../utils/constants'
import { getTime, isAfterDays, resolveStatus } from '../../utils/helpers'
import { DownTimer } from '../DownTimer'
import Radio from '../Radio/Radio'
import Status, { EnumStatusIconType } from '../Status/Status'
import css from './Departures.module.css'
import { useTranslation } from 'react-i18next'
import { FREESELL_THRESHOLD } from '../../utils/constants'

const Departures = observer(() => {
  const { t } = useTranslation()

  const departures = reservationStore.departures.map((departure, index) => {
    const {
      journeyCode,
      departureCode,
      departurePortExtCode,
      customerAllotments,
      departureDatetime,
      freeSell,
      totalBookableLength
    } = departure

    const portName =
      reservationStore.findPortByCode(departurePortExtCode || '').portName || ''

    const releaseTime = customerAllotments?.releaseTime

    const shouldShowTimer =
      !freeSell || (totalBookableLength && totalBookableLength <= FREESELL_THRESHOLD)

    return (
      <label
        key={index}
        className={classNames(css.item, {
          [css.selected]: reservationStore.departureCode === departureCode,
          [css.empty]:
            resolveStatus(departure) === AllotmentStatus.empty &&
            !freeSell &&
            totalBookableLength &&
            totalBookableLength <= FREESELL_THRESHOLD
        })}
      >
        <span className={classNames(css.time)}>
          {getTime(departureDatetime!)} &nbsp;
          <span>{portName}</span>
          {departureCode === reservationStore.bookedDeparture && (
            <span>&nbsp; Current</span>
          )}
        </span>

        {shouldShowTimer ? (
          releaseTime ? (
            <DownTimer
              timeTo={releaseTime as unknown as Date}
              className={css.downTimer}
            />
          ) : (
            <span className={css.downTimer}>--</span>
          )
        ) : (
          <span>&nbsp;</span>
        )}

        <Status
          iconType={EnumStatusIconType.circle}
          className={css.icon}
          departure={departure}
        />
        {shouldShowTimer ? (
          <span className={css.allotment}>
            {freeSell
              ? totalBookableLength
              : customerAllotments?.allotments?.highSpaceAllotment
                  ?.availableLength || '--'}
          </span>
        ) : (
          <span>&nbsp;</span>
        )}
        <Radio
          value={departureCode}
          checked={reservationStore.departureCode === departureCode}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            reservationStore.setJourneyCode(journeyCode || '')
            reservationStore.setSelectedDeparture(e.target.value)
          }}
          disabled={
            isAfterDays(parse(departureDatetime!)) ||
            (departureCode !== reservationStore.bookedDeparture &&
              (isPast(parse(departureDatetime!)) ||
                ((!customerAllotments ||
                  customerAllotments.allotments!.highSpaceAllotment!
                    .availableLength === 0) &&
                  !freeSell) ||
                ErrorStore.isLoading))
          }
        />
      </label>
    )
  })

  return (
    <div
      className={classNames(css.select, {
        [css.isLoading]: ErrorStore.isLoading
      })}
    >
      <div className={css.selectHeader}>{t('departures')}</div>
      <div className={css.selectDate}>
        {format(reservationStore.selectedDate, t('date_format'))}
      </div>
      <div
        className={classNames({
          [css.limited]: isAfterDays(reservationStore.selectedDate)
        })}
      >
        <ul className={css.list}>{departures}</ul>
      </div>
    </div>
  )
})

export default Departures
